<template>
  <!-- footer -->
  <div class="body-bottom">
    <!-- <div class="body-bottom-inner">
      <div class="ent-bottom-t">
        <div class="bottom_list">
          <span
            class="bottom_list_item"
            v-for="(item,index) of list"
            :key="index"
            @click="toA(item.url)"
          >{{item.name}}</span>
        </div>
      </div>
    </div> -->
    <div class="ent-bottom-b">
      <!-- <p>Copyright 2020 © 高校企业服务内网 All Rights Reserved. 京ICP备17040662号-4</p> -->
      <p><img src="../../assets/img/police_badge.jpg"/><span class="police_badge">京公网安备 11010802041399号</span>Copyright 2020 © 到梦空间 All Rights Reserved. <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17040662号-4</a></p>
    </div>
  </div>
</template>
<script>
import {
  Popover
} from 'element-ui'
export default {
  data () {
    return {
      list: [{
        name: '中国青年网',
        url: 'http://www.youth.cn/'
      }, {
        name: '中华全国学生联合会',
        url: 'http://qgxl.youth.cn/'
      }, {
        name: '西部计划',
        url: 'http://xibu.youth.cn/'
      }, {
        name: '爱国主义网',
        url: 'http://agzy.youth.cn/'
      }, {
        name: '中青在线',
        url: 'http://www.cyol.net/'
      }, {
        name: '中国青年创业就业基金会',
        url: 'http://www.yee.org.cn/'
      }, {
        name: '中国青年企业家协会',
        url: 'http://www.cyea.org.cn/'
      }, {
        name: '中国青年公益网',
        url: 'http://gongyi.youth.cn/'
      }, {
        name: '中国青少年发展基金会',
        url: 'http://www.cydf.org.cn/'
      }, {
        name: '中国国际青年交流中心',
        url: 'http://www.youthbridge.org.cn/'
      }, {
        name: '中国青年出版社',
        url: 'http://www.cyp.com.cn/'
      }, {
        name: '中国光华科技基金会',
        url: 'http://www.ghstf.org/'
      }, {
        name: '中国青少年研究中心',
        url: 'http://www.cycs.org/'
      }, {
        name: '中央团校',
        url: 'http://www.cyu.edu.cn/'
      }, {
        name: '中国志愿者网',
        url: 'http://www.zgzyz.org.cn/'
      }, {
        name: '全国青少年井冈山革命传统教育基地',
        url: 'http://www.qjd.org.cn/'
      }, {
        name: '人民网',
        url: 'http://www.people.com.cn/'
      }, {
        name: '新华网',
        url: 'http://www.xinhuanet.com/'
      }]
    }
  },
  components: {
    'el-popover': Popover
  },
  methods: {
    toA (url) {
      window.open(url)
    }
  }
}
</script>
<style src='./footer.css'></style>
<style lang="scss" scoped>
// footer
.body-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  .body-bottom-inner {
    background: #2e3033;
    padding: 40px 0 30px 0;
  }

  .ent-bottom-t-l h5 {
    font-size: 14px;
    color: #fff;
    margin-bottom: 27px;
  }

  .bottom-item-list {
    color: #fff;
    display: flex;
  }

  .bottom-item-list li {
    padding-right: 10px;
    padding-left: 10px;
    font-size: 12px;
    color: #bebebe;
    border-left: 1px solid #bebebe;
    cursor: pointer;
  }

  .bottom-item-list li:first-child {
    border-left: 0;
    padding-left: 0;
  }

  .icon-contact-qq {
    height: 19px;
    width: 19px;
    background-image: url("../../assets/img/icon-contact-qq.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-right: 15px;
    cursor: pointer;
  }

  .icon-contact-wechat {
    height: 19px;
    width: 19px;
    background-image: url("../../assets/img/icon-contact-wechat.png");
    background-repeat: no-repeat;
    background-size: 85% 85%;
    cursor: pointer;
  }

  .contact-info {
    margin-top: 20px;
    color: #bebebe;
    font-size: 12px;
  }

  .ent-bottom-contact {
    text-align: end;
  }

  .ent-bottom-t {
    background: #2e3033;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }

  .ent-bottom-b {
    height: 44px;
    line-height: 44px;
    background: #2b2c2e;
    color: #999;
    font-size: 12px;
    text-align: center;
    a{
      color: #999;
      text-decoration: none;
    }
    img {
      vertical-align: -5px;
      margin-right: 3px;
      width: 18px;
    }

    .police_badge {
      margin-right: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue